import { memo, useMemo } from 'react';

import { startOfDayInTimeZone } from '../../utils/dateGrid';
import TimeGrid from '../TimeGrid';

import type { DayViewProps } from './types';

function DayView({ date, timeZone, ...rest }: DayViewProps) {
  const days = useMemo(() => [startOfDayInTimeZone(date, timeZone)], [date, timeZone]);
  return <TimeGrid days={days} timeZone={timeZone} {...rest} />;
}

export default memo(DayView);
